import { buildChildURL } from '@centric-os/helpers';
import type { RouteRecordRaw } from 'vue-router';
import { DiscountsRouteNames, DiscountsRoutePathNames } from '../enums';
import { beforeEnter } from './guards/index';
import { updateRoute } from './update/update';

const List = () => import('../components/list/List.vue');
const Create = () => import('../components/create/Create.vue');

const listRoute = {
  path: buildChildURL(DiscountsRoutePathNames.LIST),
  name: DiscountsRouteNames.DISCOUNTS_LIST,
  component: List,
  beforeEnter: beforeEnter,
} as RouteRecordRaw;

const createRoute = {
  path: buildChildURL(DiscountsRoutePathNames.CREATE),
  name: DiscountsRouteNames.DISCOUNTS_CREATE,
  component: Create,
  beforeEnter: beforeEnter,
} as RouteRecordRaw;

const childRoutes: RouteRecordRaw[] = [listRoute, createRoute, updateRoute];

export default childRoutes;
